import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../nav/crowpay.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { UploadSettlementDocsDialog3j42xvchj1p9v as UploadSettlementDocsDialog } from './UploadSettlementDocsDialog.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  GroupedInformationSemantic_getInstance10la8ntbgzaf6 as GroupedInformationSemantic_getInstance,
  get_outlinedfhcs63de0vzu as get_outlined,
} from '../../../theming/appTheme.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  title1ahgushtajx2d as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../theming/Titles.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_bold1rri6ahk98puv as get_bold } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { label287uhiq3m9m4z as label2 } from '../../label2.mjs';
import {
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../files/renderFiles.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  exit12upnsqp8029y as exit,
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
  HasFallback3lthr8mgiugg2 as HasFallback,
} from '../../../screens/common/DialogWithDialog.mjs';
import { Data3qblafqxenieu as Data } from '../../../screens/common/AuthorizedProjectView.mjs';
import {
  Page1o437w9xuocrm as Page,
  get_titlelss9nf4gv6ut as get_title,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../../../screens/contractor/ContractorProject.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from '../../../screens/client/ClientProject.mjs';
import { AnonymousProjectView24hg9uw1el0c2 as AnonymousProjectView } from '../../../screens/common/AnonymousProjectView.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ph2_1.jfy();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  var tmp0_elvis_lhs = $this.ph2_1.uf2_1;
  tmp.nd6(new (UploadSettlementDocsDialog())(tmp_1, $this.ph2_1.tf2_1, tmp0_elvis_lhs == null ? $this.ph2_1 : tmp0_elvis_lhs));
  return Unit_instance;
}
function page($this, _this__u8e3s4) {
  var tmp = _this__u8e3s4.hbb(GroupedInformationSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  title(view, ($this$title) => {
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
    reactiveScope($this$title, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.baj($this.jfy()).d7b_1 + ' Settlement Documentation';
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp_0 = $this.oh2();
  forEachUpdating(view_0, tmp_0, VOID, ($this$forEachUpdating, settlement) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.ebb(p, view);
    view.xbm(true);
    view.zb8(get_AppDimensions().ng2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
    var breakpoint = get_AppDimensions().hg2_1;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var tmp = view_0.ibb(get_centered(view_0), get_bold(view_0));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl_0(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_0(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$2 = $this$reactiveScope.baj(settlement).k7s_1 ? $this$reactiveScope.baj($this.wgk()).f5c_1 : $this$reactiveScope.baj($this.fgl()).x5i_1;
      this_0.set(tmp$ret$2);
      return Unit_instance;
    });
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp, view_1);
    var tmp_2 = view_0.ibb(get_centered(view_0), get_expanding(view_0));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_content_$ref_4pzcwl_1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb_1(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$9 = format($this$reactiveScope.baj(settlement).j7s_1.q54_1, Formats_getInstance().k8z_1);
      this_1.set(tmp$ret$9);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view_0.jbb(tmp_2, view_2);
    view.fbb(p_0, view_0);
    var tmp_5 = get_outlined(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    view_3.xbm(true);
    label2(view_3, 'Summary', VOID, ($this$label2) => {
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextView())($this$label2.pc());
      var tmp0_elvis_lhs = $this$label2.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
      $this$label2.ebb(p, view);
      view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl_2(view);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_2(view));
      reactiveScope(view, ($this$reactiveScope) => {
        var tmp$ret$19 = $this$reactiveScope.baj(settlement).l7s_1;
        this_0.set(tmp$ret$19);
        return Unit_instance;
      });
      $this$label2.fbb(p, view);
      return view;
    });
    label2(view_3, 'Documents', VOID, ($this$label2) => {
      var tmp = get_scrollingHorizontally($this$label2);
      return $this$label2.jbb(tmp, renderFiles($this$label2, lens(settlement, ViewSettlementDocs$page$lambda$lambda$lambda), get_rem(8)));
    });
    view.fbb(p_3, view_3);
    view.jbb(tmp_5, view_3);
    $this$forEachUpdating.fbb(p, view);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.zb8(get_AppDimensions().ig2_1);
  var tmp_1 = get_primaryButton(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  specCenteredText(view_2, '+ Upload Settlement Documents');
  onClick(view_2, VOID, VOID, ViewSettlementDocs$page$slambda_0($this));
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_1, view_2);
  var tmp_2 = get_textButton(view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  specCenteredText(view_3, 'Go Back');
  onClick(view_3, VOID, VOID, ViewSettlementDocs$page$slambda_2($this, view_3));
  view_1.fbb(p_3, view_3);
  view_1.jbb(tmp_2, view_3);
  view.fbb(p_1, view_1);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var ViewSettlementDocs$renderAsDialog$slambdaClass;
function ViewSettlementDocs$renderAsDialog$slambda() {
  if (ViewSettlementDocs$renderAsDialog$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ViewSettlementDocs$renderAsDialog$slambdaClass = $;
  }
  return ViewSettlementDocs$renderAsDialog$slambdaClass;
}
function ViewSettlementDocs$renderAsDialog$slambda_0() {
  var i = new (ViewSettlementDocs$renderAsDialog$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ViewSettlementDocs$page$lambda$lambda$lambda(it) {
  return it.m7s_1;
}
var ViewSettlementDocs$page$slambdaClass;
function ViewSettlementDocs$page$slambda() {
  if (ViewSettlementDocs$page$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ph2_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ViewSettlementDocs$page$slambdaClass = $;
  }
  return ViewSettlementDocs$page$slambdaClass;
}
function ViewSettlementDocs$page$slambda_0(this$0) {
  var i = new (ViewSettlementDocs$page$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ViewSettlementDocs$page$slambdaClass_0;
function ViewSettlementDocs$page$slambda_1() {
  if (ViewSettlementDocs$page$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.qh2_1 = this$0;
        this.rh2_1 = $$this$button;
      }
      sao($completion) {
        exit(this.qh2_1, this.rh2_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ViewSettlementDocs$page$slambdaClass_0 = $;
  }
  return ViewSettlementDocs$page$slambdaClass_0;
}
function ViewSettlementDocs$page$slambda_2(this$0, $$this$button) {
  var i = new (ViewSettlementDocs$page$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ViewSettlementDocsClass;
function ViewSettlementDocs() {
  if (ViewSettlementDocsClass === VOID) {
    class $ {
      constructor(projectId, lens, source) {
        source = source === VOID ? null : source;
        var tmp = this;
        tmp.rf2_1 = source == null ? new (Data())(lens, projectId) : source;
        this.sf2_1 = projectId;
        this.tf2_1 = lens;
        this.uf2_1 = source;
      }
      jf8() {
        return this.sf2_1;
      }
      cgh(_this__u8e3s4) {
        var tmp = this.uf2_1;
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Page()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp_1;
          switch (this.tf2_1.b4_1) {
            case 0:
              tmp_1 = new (ContractorProject())(this.sf2_1);
              break;
            case 1:
              tmp_1 = new (ClientProject())(this.sf2_1);
              break;
            case 2:
              tmp_1 = new (AnonymousProjectView())(this.sf2_1);
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
      wgs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(ViewSettlementDocs$renderAsDialog$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp_0 = view.ibb(get_atTopCenter(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40)));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var tmp0_vertical = get_rem(3);
        var tmp1_horizontal = get_rem(0);
        view_0.hba(Edges().cd0(tmp1_horizontal, tmp0_vertical));
        view_0.cb9(true);
        view_0.jbb(view_0.hbb(DialogSemantic_getInstance()), page(this, view_0));
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      vgs(_this__u8e3s4) {
        return _this__u8e3s4.jbb(get_scrolling(_this__u8e3s4), page(this, _this__u8e3s4));
      }
      jfy() {
        return this.rf2_1.jfy();
      }
      tgm() {
        return this.rf2_1.tgm();
      }
      xgz() {
        return this.rf2_1.xgz();
      }
      wgk() {
        return this.rf2_1.wgk();
      }
      fgl() {
        return this.rf2_1.fgl();
      }
      ugm() {
        return this.rf2_1.ugm();
      }
      vgv() {
        return this.rf2_1.vgv();
      }
      lgy() {
        return this.rf2_1.lgy();
      }
      igt() {
        return this.rf2_1.igt();
      }
      jgt() {
        return this.rf2_1.jgt();
      }
      hgt() {
        return this.rf2_1.hgt();
      }
      bgt() {
        return this.rf2_1.bgt();
      }
      egt() {
        return this.rf2_1.egt();
      }
      ngf() {
        return this.rf2_1.ngf();
      }
      oh2() {
        return this.rf2_1.oh2();
      }
      mgf() {
        return this.rf2_1.mgf();
      }
      sh2() {
        return this.rf2_1.sh2();
      }
    }
    protoOf($).ud6 = render;
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'ViewSettlementDocs', VOID, VOID, [DialogOrPage(), HasFallback()]);
    ViewSettlementDocsClass = $;
  }
  return ViewSettlementDocsClass;
}
//region block: exports
export {
  ViewSettlementDocs as ViewSettlementDocs1y21duy3panzg,
};
//endregion

//# sourceMappingURL=ViewSettlementDocs.mjs.map
